'use client';

import styled from 'styled-components';

import { breakpoints } from '@styles/breakpoint';
import { Spacers } from '@styles/theme';

export const ButtonsContainer = styled.div`
  display: grid;
  gap: ${Spacers.BASE}rem;
  padding-top: ${Spacers.BASE}rem;
  grid-column: 1 / -1;

  ${breakpoints.desktopOrBigger} {
    // Centers content with one-column margins in 12-column desktop grid.
    // Using grid-column: n/-n pattern for horizontal structure only
    // (vertical remains dynamic in this template)
    grid-column: 2 / -2;
  }
`;
